module.exports = __webpack_public_path__ + "static/media/downarrow.5ad19897.svg";